module.exports = __webpack_public_path__ + "sheya.png?a2edcffd57b1b00405d14cb5339cb998";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sheya.png
// module id = 46
// module chunks = 0